module.exports = __webpack_public_path__ + "img/SKMJ_car2.d1a913c8.jpg";